import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import createLocation from 'utils/createLocation';
import getBasicDate from 'utils/dates/getBasicDate';
import { getSelectedAndTodayDate } from 'utils/timezone';
import useSearchParams from 'hooks/useSearchParams';
import Stack from 'components/Stack';
import TitleCard from 'components/TitleCard';
import Button from 'components/Button';
import DatePicker from 'components/DatePicker';
import FormField from 'components/FormField';
import SessionsTable from './SessionsTable';
import { sessionQueryParameters } from '../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var startDateQueryParameter = sessionQueryParameters.startDate;

// Default start date is 7 days ago from today, to show sessions from the last 7 days
function getDefaultStartDate() {
  var defaultStartDate = new Date();
  defaultStartDate.setDate(defaultStartDate.getDate() - 7);
  return getBasicDate(defaultStartDate);
}
function SessionsListPage(_ref) {
  var eventId = _ref.eventId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var location = useLocation();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  var formattedDate = searchParams[startDateQueryParameter] || getDefaultStartDate();
  var selectedDate = React.useMemo(function () {
    return getSelectedAndTodayDate(formattedDate).selectedDate;
  }, [formattedDate]);
  return /*#__PURE__*/_jsx(TitleCard, {
    title: t('sessions_list_title'),
    variant: "raised",
    sideContent: /*#__PURE__*/_jsx(Button, {
      icon: "plus",
      size: "medium",
      variant: "primary",
      onClick: function onClick() {
        return navigate(createLocation(location, {
          sessionId: 'new'
        }));
      },
      children: t('actions_create_session')
    }),
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsx(FormField, {
        horizontal: true,
        horizontalLabelWidth: "190",
        required: true,
        label: t('form_sessions_starting_after_colon'),
        children: /*#__PURE__*/_jsx(DatePicker, {
          dateFormat: "dd/MM/yyyy",
          preventOpenOnFocus: true,
          selected: selectedDate,
          onChange: function onChange(date) {
            setSearchParams(_defineProperty(_defineProperty({}, startDateQueryParameter, getBasicDate(date)), sessionQueryParameters.page, 1));
          }
        })
      }), /*#__PURE__*/_jsx(SessionsTable, {
        eventId: eventId,
        startDate: formattedDate
      })]
    })
  });
}
export default SessionsListPage;